<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  data(){
    return {
      nowStatus:0
    }
  },
  created(){
    if(!localStorage.getItem('portalUserName') || !localStorage.getItem('portalToken')){
      localStorage.removeItem('portalToken');
      localStorage.removeItem('portalUserName');
      this.$router.push({path:'/'})
    }
  }
}
</script>

<style>
#app {
  height:100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
